import EnoughFilledRequired from '@/components/messageComponents/EnoughFilledRequired.vue'
import PaymentResult from '@/components/messageComponents/PaymentResult.vue'
import PaymentError from '@/components/messageComponents/PaymentError.vue'

export const messageComponents = {
  EnoughFilledRequired,
  PaymentResult,
  PaymentError,
}
